import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import NewRecordForm from 'modules/dashboard/form/Form';

const ButtonUpdate = ({ record, onEditSuccess }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      <Button icon={<EditOutlined />} block onClick={showModal}>
        Thông tin UV
      </Button>
      <Modal
        title="Cập nhật thông tin"
        open={isModalOpen}
        footer={null}
        onCancel={handleCloseModal}
      >
        <NewRecordForm
          record={record}
          onSuccess={() => {
            if (typeof onEditSuccess === 'function') {
              onEditSuccess();
            }
            handleCloseModal();
          }}
        />
      </Modal>
    </>
  );
};

export default ButtonUpdate;
